import axios from 'axios';
import { useMutation, useQuery, useQueryClient } from 'react-query';

const apiUrl = () => process.env.REACT_APP_BASIX_API || '';

// item 315 — admin-defined custom commission reasons (on top of the 4 built-ins).
// item 449 — attribution = who earns this reason (0 Everyone / 1 Customer IO rep /
// 2 Customer PO rep + staff / 3 Assigned project lead).
export interface CommissionReason {
  id: string;
  name: string;
  systemKey?: string | null;
  attribution?: number;
}

const useCommissionReasons = () => {
  const queryClient = useQueryClient();
  const invalidate = () => queryClient.invalidateQueries('commissionReasons');

  const query = useQuery('commissionReasons', async (): Promise<CommissionReason[]> => {
    const { data } = await axios.get(`${apiUrl()}CommissionReason`);
    return data;
  });

  const saveMutation = useMutation(
    (input: { id?: string; name: string; attribution?: number }) => axios.post(`${apiUrl()}CommissionReason`, input),
    { onSuccess: invalidate },
  );
  const archiveMutation = useMutation(
    (id: string) => axios.delete(`${apiUrl()}CommissionReason/${id}`),
    { onSuccess: invalidate },
  );

  return {
    reasons: query.data ?? [],
    status: query.status,
    save: (name: string, id?: string, attribution?: number) => saveMutation.mutateAsync({ id, name, attribution }),
    archive: (id: string) => archiveMutation.mutateAsync(id),
    isBusy: saveMutation.isLoading || archiveMutation.isLoading,
  };
};

export default useCommissionReasons;
